import "../../style/animations.css";
import { useInView } from "../../hooks/useInView";

import { useMemo } from "react";
import { useHomePage } from "../../context/HomePageContext";
import { useLanguage } from "../../context/LanguageContext";
import { resolveCoreValues } from "../../lib/homePageContent";

export default function CoreValuesSection() {
  const { data } = useHomePage();
  const { language } = useLanguage();
  const coreValues = useMemo(() => resolveCoreValues(data?.core_values, language), [data, language]);

  const { ref, inView } = useInView<HTMLDivElement>();

  // 4 kartu (bawaan) = grid 4 kolom seperti semula. Kurang dari itu -> dipusatkan
  // dengan lebar kartu yang sama, supaya tidak menumpuk di kiri.
  const fewCards = coreValues.items.length < 4;

  return (
    <section className="w-full px-6 py-16 lg:px-20 lg:py-20">
      <div ref={ref} className="mx-auto w-full max-w-[1327px]">
        {/* TITLE */}
        <div
          className={`
            mb-14
            flex
            justify-center
            reveal-up
            ${inView ? "is-visible" : ""}
          `}>
          <h2
            className="
              text-center
              text-[38px]
              font-bold
              text-[#324A5A]
              lg:text-[56px]
            ">
            {coreValues.title}
          </h2>
        </div>

        {/* CARD LIST */}
        <div
          className={`
            grid
            grid-cols-1
            gap-6
            sm:grid-cols-2
            ${fewCards ? "lg:flex lg:flex-wrap lg:justify-center" : "lg:grid-cols-4"}
          `}>
          {coreValues.items.map((item, index) => (
            <div
              key={item.key}
              style={{
                transitionDelay: inView ? `${index * 120}ms` : "0ms",
              }}
              className={`
                group
                reveal-scale
                ${inView ? "is-visible" : ""}
                ${fewCards ? "lg:w-[calc((100%-72px)/4)]" : ""}

                flex
                min-h-[385px]
                flex-col
                items-center

                rounded-[34px]

                bg-[linear-gradient(180deg,#73B4C2_0%,#324A5A_100%)]

                px-8
                py-10

                text-center

                transition-all
                duration-300

                hover:-translate-y-2
                hover:shadow-2xl
              `}>
              {/* ICON */}
              <div
                className="
                  flex
                  h-[110px]
                  w-full
                  items-center
                  justify-center

                  transition-transform
                  duration-300

                  group-hover:scale-110
                ">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="
                    h-20
                    w-20
                    object-contain

                    lg:h-24
                    lg:w-24
                  "
                />
              </div>

              {/* TITLE */}
              <div
                className="
                  mt-6
                  flex
                  h-[60px]
                  w-full
                  items-center
                  justify-center
                ">
                <h3
                  className="
                    text-[22px]
                    font-bold
                    leading-tight
                    text-white
                  ">
                  {item.title}
                </h3>
              </div>

              {/* DESCRIPTION */}
              <div
                className="
                  mt-3
                  flex
                  min-h-[90px]
                  w-full
                  items-start
                  justify-center
                ">
                <p
                  className="
                    max-w-[240px]
                    text-[16px]
                    leading-[30px]
                    text-white
                  ">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
